import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'confirm' | 'alert' | 'success' | 'info';
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'confirm',
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation('common');
  const resolvedConfirmText = confirmText ?? t('delete');
  const resolvedCancelText = cancelText ?? t('cancel');

  if (!isOpen) return null;

  const isAlertMode = variant === 'alert' || variant === 'success';
  const buttonClass = variant === 'success' ? 'confirm-button confirm-button--success'
    : variant === 'info' ? 'confirm-button confirm-button--info'
    : 'confirm-button';

  return (
    <div className="confirm-dialog-overlay" onClick={isAlertMode ? onCancel : undefined}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <h3>{title}</h3>
          <button className="close-button" onClick={onCancel}>×</button>
        </div>
        <div className="confirm-dialog-content">
          <p>{message}</p>
        </div>
        <div className="confirm-dialog-actions">
          {!isAlertMode && (
            <button
              className="cancel-button"
              onClick={onCancel}
            >
              {resolvedCancelText}
            </button>
          )}
          <button
            className={buttonClass}
            onClick={onConfirm}
          >
            {isAlertMode ? 'OK' : resolvedConfirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
